import { render } from "./SubPageHeading.vue?vue&type=template&id=11e20842&scoped=true&ts=true"
import script from "./SubPageHeading.vue?vue&type=script&lang=ts"
export * from "./SubPageHeading.vue?vue&type=script&lang=ts"

import "./SubPageHeading.vue?vue&type=style&index=0&id=11e20842&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e20842"]])

export default __exports__